"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendSignedContractMailMutation = void 0;
exports.sendSignedContractMailMutation = `
  mutation sendSignedContractMail($id: String!, $attachmentId: String!) {
    sendSignedContractMail(orderId: $id, attachmentId: $attachmentId) {
      sentUser
      sentCustomer
    }
  }
`;
//# sourceMappingURL=vehicle-order.js.map